export default __webpack_public_path__ + "static/media/04.da9bdb73.jpeg";